
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clases/page/5",
      function () {
        return require("private-next-pages/clases/page/5.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clases/page/5"])
      });
    }
  